import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from '../components/Hero';
import Gallery from '../components/Gallery';
import About from '../components/About';
import Services from '../components/Services';
import Contact from '../components/Contact';
import ScrollAnimation from '../components/ScrollAnimation';
import BeforeAfter from '../components/BeforeAfter';
import Testimonials from '../components/Testimonials';
import Stats from '../components/Stats';
import { galleryData } from '../data/mockData';

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    // Handle scrolling to section if hash is present in URL
    if (location.hash) {
      const sectionId = location.hash.substring(1); // Remove the '#'
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerHeight = 80; // Account for fixed header
          const elementPosition = element.offsetTop - headerHeight;
          
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 500); // Longer delay to ensure all components are rendered
    }
  }, [location.hash]);

  // Also handle initial page load with hash
  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.substring(1);
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const headerHeight = 80;
          const elementPosition = element.offsetTop - headerHeight;
          
          window.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          });
        }
      }, 1000); // Even longer delay for initial page load
    }
  }, []); // Run only on mount
  return (
    <div className="min-h-screen">
      <Hero />

      {/* Stats Section */}
      <ScrollAnimation animation="fadeInUp">
        <Stats />
      </ScrollAnimation>

      {/* Before/After Section */}
      <ScrollAnimation animation="fadeInUp">
        <BeforeAfter />
      </ScrollAnimation>

      <section id="gallery" className="py-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-amber-900 mb-6 leading-tight">
              הגלריות שלנו
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-amber-600 mx-auto mb-6 rounded-full"></div>
            <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
              צפו בעבודות המרהיבות שלנו בתחומי הצביעה, עבודות העץ והחידושים המתקדמים
            </p>
          </div>

          <ScrollAnimation animation="fadeInUp" delay={200}>
            <Gallery
              title={galleryData.color.title}
              images={galleryData.color.images.slice(0, 10).map(img => img.url)}
              categoryLink="/gallery/color"
            />
          </ScrollAnimation>

          <ScrollAnimation animation="fadeInUp" delay={400}>
            <Gallery
              title={galleryData.wood.title}
              images={galleryData.wood.images.slice(0, 10).map(img => img.url)}
              categoryLink="/gallery/wood"
            />
          </ScrollAnimation>

          <ScrollAnimation animation="fadeInUp" delay={600}>
            <Gallery
              title={galleryData.renovations.title}
              images={galleryData.renovations.images.slice(0, 10).map(img => img.url)}
              categoryLink="/gallery/renovations"
            />
          </ScrollAnimation>
        </div>
      </section>

      <div id="about">
        <ScrollAnimation animation="fadeInUp">
          <About />
        </ScrollAnimation>
      </div>

      <ScrollAnimation animation="fadeInUp" delay={200}>
        <Services />
      </ScrollAnimation>

      {/* Testimonials Section */}
      <ScrollAnimation animation="fadeInUp">
        <Testimonials />
      </ScrollAnimation>

      <div id="contact">
        <ScrollAnimation animation="fadeInUp" delay={400}>
          <Contact />
        </ScrollAnimation>
      </div>
    </div>
  );
};

export default HomePage;